module.exports = (number) => {
  let value = number?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ",00";
  return value;
};
